import { Action } from '@/_core/fluxstore/types';
import { NotificationSettingsState } from '../types';
import { useNotificationSettingsStore } from '../useModule';
import { UserNotificationSettingsQueryResult } from '@/api/notification-settings/queries';

const { registerReducer } = useNotificationSettingsStore();

export class InitNotificationSettings extends Action<NotificationSettingsState> {
    public static ACTION_TYPE = 'InitNotificationSettings';
    public constructor(public res: UserNotificationSettingsQueryResult) {
        super(InitNotificationSettings.ACTION_TYPE);
    }
}

const reducer = (state: NotificationSettingsState, action: InitNotificationSettings): void => {
    state.id = action.res.Id;
    state.autoWatchMyCards = action.res.AutoWatchMyCards;

    state.changeRights.mapFrom(action.res.ChangeRights);

    state.firstTimeVisitedMyBoard.mapFrom(action.res.FirstTimeVisitedMyBoard);

    state.invitedMe.mapFrom(action.res.InvitedMe);

    state.someoneCommentedOrChangedWatchedCards.mapFrom(action.res.SomeoneCommentedOrChangedWatchedCards);

    state.someoneMentionedMe.mapFrom(action.res.SomeoneMentionedMe);

    state.someonePostedOnBoardDiscussions.mapFrom(action.res.SomeonePostedOnBoardDiscussions);

    state.slackIsConnected = action.res.SlackIsConnected;
};

//@ts-ignore
registerReducer(InitNotificationSettings.ACTION_TYPE, reducer);
